module.exports = __webpack_public_path__ + "static/media/Pink_Button@3x.c45a166a.png";